module.exports = __webpack_public_path__ + "img/report_candidate_new.2e801be2.svg";